import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { observable } from "mobx";
import { observer } from "mobx-react";
import classNames from "classnames";
import { Dimmer, Loader } from "semantic-ui-react";
import PropTypes from "prop-types";
import DomainNameUtils from "~/utils/DomainNameUtils";
import LoginStore from "../stores/LoginStore";
import FlashMessageStore from "~/stores/FlashMessageStore";
import CustomBrandingStyle from "~/components/CustomBrandingStyle";

@observer
class LogoutPage extends Component {
  /**
   * @type {LoginStore}
   */
  @observable loginStore;

  constructor(props) {
    super(props);

    this.loginStore = new LoginStore();
  }

  componentDidMount() {
    const { t } = this.props;

    document.title = t("login:loggingYouOutPleaseWait");

    this.loginStore
      .logout()
      .then(() => {
        const { flashMessageStore } = this.props;
        flashMessageStore.setMessage(t("login:successfullyLoggedOut"));
      })
      .catch(() => {
        const { flashMessageStore } = this.props;
        flashMessageStore.setMessage(t("login:anErrorOccurredLoginOut"), "negative");
      })
      .finally(() => {
        const { history } = this.props;
        history.push("/");
      });
  }

  render() {
    return (
      <>
        <CustomBrandingStyle />
        <main
          className={classNames("login", {
            "custom-domain": DomainNameUtils.isCustomDomain(),
          })}
        >
          <Dimmer active inverted>
            <Loader />
          </Dimmer>
        </main>
      </>
    );
  }
}

LogoutPage.propTypes = {
  flashMessageStore: PropTypes.instanceOf(FlashMessageStore).isRequired,
  history: PropTypes.any,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(LogoutPage);
